import WarrantyPromo from 'components/Article/content/WarrantyPromo';
import ContentAd from 'components/Ad/ContentAd';

export interface AdProps {
  value: string;
}

export function Ad({ value }: AdProps): JSX.Element {
  return value === 'warrantyPromo' ? <WarrantyPromo /> : <ContentAd adType={value} />;
}

export default {
  ad: Ad,
};
